import React from 'react'
// AUTO-INJECTED by Upbo deploy — do not edit. Stops a single render error from
// white-screening the whole site (e.g. React #31 from rendering an object child).
export class UpboBoundary extends React.Component<{ children: React.ReactNode }, { error: Error | null }> {
  constructor(props: any) { super(props); this.state = { error: null } }
  static getDerivedStateFromError(error: Error) { return { error } }
  componentDidCatch(error: Error) { try { console.error('[upbo-guard] caught render error:', error) } catch {} }
  render() {
    if (this.state.error) {
      return React.createElement('div', { style: { padding: 24, fontFamily: 'system-ui, sans-serif', color: '#b00020' } },
        React.createElement('h2', { style: { margin: '0 0 8px' } }, 'Đã xảy ra lỗi hiển thị'),
        React.createElement('p', { style: { margin: 0, color: '#555' } }, String(this.state.error?.message || this.state.error)))
    }
    return this.props.children as any
  }
}
